var _rect, _rect2, _rect3, _rect4, _circle, _circle2, _circle3, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialAutomationAnalytics(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 560 380",
    fill: "none",
    role: "img",
    "aria-label": "Social media analytics dashboard",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 560,
    height: 380,
    rx: 20,
    fill: "#F2F4FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 512,
    height: 332,
    rx: 16,
    fill: "#fff",
    stroke: "#DDE3F0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 44,
    width: 472,
    height: 36,
    rx: 10,
    fill: "#F7F8FC"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 56,
    width: 88,
    height: 12,
    rx: 6,
    fill: "#002454",
    opacity: 0.18
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 420,
    cy: 62,
    r: 10,
    fill: "#9e00ff",
    opacity: 0.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 448,
    cy: 62,
    r: 10,
    fill: "#002454",
    opacity: 0.18
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 476,
    cy: 62,
    r: 10,
    fill: "#25D366",
    opacity: 0.25
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 96,
    width: 300,
    height: 180,
    rx: 14,
    fill: "#FAFBFD",
    stroke: "#E2E8F0"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 112,
    width: 120,
    height: 10,
    rx: 5,
    fill: "#002454",
    opacity: 0.18
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 240,
    width: 36,
    height: 20,
    rx: 6,
    fill: "#9e00ff",
    opacity: 0.55
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 108,
    y: 220,
    width: 36,
    height: 40,
    rx: 6,
    fill: "#002454",
    opacity: 0.35
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 156,
    y: 200,
    width: 36,
    height: 60,
    rx: 6,
    fill: "#9e00ff",
    opacity: 0.75
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 204,
    y: 180,
    width: 36,
    height: 80,
    rx: 6,
    fill: "#25D366",
    opacity: 0.55
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 252,
    y: 160,
    width: 36,
    height: 100,
    rx: 6,
    fill: "#9e00ff",
    opacity: 0.85
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 96,
    width: 152,
    height: 84,
    rx: 14,
    fill: "#F4F2FA",
    stroke: "#E6DDF5"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 112,
    width: 80,
    height: 8,
    rx: 4,
    fill: "#002454",
    opacity: 0.2
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 128,
    width: 112,
    height: 18,
    rx: 6,
    fill: "#9e00ff",
    opacity: 0.75
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 154,
    width: 88,
    height: 8,
    rx: 4,
    fill: "#25D366",
    opacity: 0.55
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 364,
    y: 196,
    width: 152,
    height: 80,
    rx: 14,
    fill: "#F4F2FA",
    stroke: "#E6DDF5"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 212,
    width: 80,
    height: 8,
    rx: 4,
    fill: "#002454",
    opacity: 0.2
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 228,
    width: 112,
    height: 18,
    rx: 6,
    fill: "#002454",
    opacity: 0.65
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 380,
    y: 254,
    width: 88,
    height: 8,
    rx: 4,
    fill: "#9e00ff",
    opacity: 0.45
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 44,
    y: 292,
    width: 472,
    height: 44,
    rx: 12,
    fill: "#FAFBFD",
    stroke: "#E2E8F0"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 306,
    width: 140,
    height: 8,
    rx: 4,
    fill: "#002454",
    opacity: 0.18
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 60,
    y: 320,
    width: 220,
    height: 6,
    rx: 3,
    fill: "#9e00ff",
    opacity: 0.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialAutomationAnalytics);
export default __webpack_public_path__ + "static/media/social-automation-analytics.24c83a3ab5d39dd3b8e757555fc9a45c.svg";
export { ForwardRef as ReactComponent };